module.exports = __webpack_public_path__ + "static/media/linkedInIcon.4a7a3d2e.svg";